import * as type from '../actions/types';

const initialState = {
  data: { revenue: 0, users: 0, month: 0 },
  pending: false,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PAUSE_PROJECTION_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.FETCH_PAUSE_PROJECTION_SUCCESS:
      const { data } = action.payload; // should be users and month
      return {
        ...state,
        data,
        pending: false,
        success: true,
      };
    case type.FETCH_PAUSE_PROJECTION_FAILURE:
      return {
        ...state,
        data: {},
        error: action.payload,
        pending: false,
      };

    default:
      return state;
  }
};
